import React from 'react';

const VowAILogo = ({ className = "h-8" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      {/* Heart with Tilted Diamond Wedding Ring */}
      <div className="relative">
        <svg 
          width="52" 
          height="52" 
          viewBox="0 0 40 40" 
          className="drop-shadow-lg"
        >
          <defs>
            {/* Glowing Heart Gradient */}
            <radialGradient id="heartGlow" cx="50%" cy="40%" r="60%">
              <stop offset="0%" stopColor="#FB7185" />
              <stop offset="30%" stopColor="#F43F5E" />
              <stop offset="60%" stopColor="#EC4899" />
              <stop offset="100%" stopColor="#FBBF24" />
            </radialGradient>
            
            {/* Wedding Ring Gradient */}
            <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FEF3C7" />
              <stop offset="30%" stopColor="#FBBF24" />
              <stop offset="70%" stopColor="#F59E0B" />
              <stop offset="100%" stopColor="#D97706" />
            </linearGradient>
            
            {/* Diamond Gradient */}
            <radialGradient id="diamondGrad" cx="50%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#FFFFFF" />
              <stop offset="30%" stopColor="#FEF3C7" />
              <stop offset="70%" stopColor="#FBBF24" />
              <stop offset="100%" stopColor="#F59E0B" />
            </radialGradient>
            
            {/* Heart Glow Effect */}
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge> 
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Glowing Heart */}
          <path
            d="M20 32c-1.5-1.5-14-9-14-18 0-5 4-9 9-9 2.5 0 4.7 1 6.3 2.6C22.8 6 25 5 27.5 5c5 0 9 4 9 9 0 9-12.5 16.5-14 18z"
            fill="url(#heartGlow)"
            filter="url(#glow)"
            className="animate-pulse"
            style={{ animationDuration: '3s' }}
          />
          
          {/* Heart Inner Highlight */}
          <path
            d="M20 28c-1-1-10-6.5-10-13 0-3.5 2.8-6.5 6.5-6.5 1.8 0 3.4 0.7 4.5 1.8C22.1 9.2 23.7 8.5 25.5 8.5c3.7 0 6.5 3 6.5 6.5 0 6.5-9 12-10 13z"
            fill="none"
            stroke="#FEF3C7"
            strokeWidth="1"
            opacity="0.8"
          />
          
          {/* Tilted Wedding Ring - Like Arrow Through Heart */}
          <g transform="rotate(45 20 20)">
            {/* Ring Band */}
            <ellipse 
              cx="20" 
              cy="20" 
              rx="12" 
              ry="3" 
              fill="none" 
              stroke="url(#ringGradient)" 
              strokeWidth="2.5"
            />
            <ellipse 
              cx="20" 
              cy="20" 
              rx="10" 
              ry="2" 
              fill="none" 
              stroke="#FEF3C7" 
              strokeWidth="0.8"
              opacity="0.7"
            />
            
            {/* Diamond on Ring */}
            <g transform="translate(32, 20)">
              <path
                d="M0 -3 L2 -1 L2 1 L0 3 L-2 1 L-2 -1 Z"
                fill="url(#diamondGrad)"
                stroke="#F59E0B"
                strokeWidth="0.3"
                className="animate-pulse"
                style={{ animationDuration: '2s' }}
              />
              {/* Diamond sparkle */}
              <circle cx="0" cy="0" r="0.5" fill="#FFFFFF" opacity="0.9" />
            </g>
          </g>
          
          {/* Magical Sparkles Around */}
          <g className="animate-pulse" style={{ animationDuration: '2.5s' }}>
            <path d="M8 8 L10 6 L12 8 L10 10 Z" fill="#FBBF24" opacity="0.8" />
            <path d="M32 8 L34 6 L36 8 L34 10 Z" fill="#F472B6" opacity="0.8" />
            <path d="M8 32 L10 30 L12 32 L10 34 Z" fill="#A855F7" opacity="0.8" />
            <circle cx="35" cy="25" r="1" fill="#FBBF24" />
            <circle cx="5" cy="15" r="1" fill="#EC4899" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default VowAILogo;
